export default "__VITE_ASSET__CdDXxZ_t__"